import React from "react";
import pic from "../../assets/images/home.png";
import { Link, animateScroll as scroll } from "react-scroll";
const Home = () => {
  return (
    <section id="home" className="home ">
      <div className="home__container container">
        <div className="home__content">
          <div className="home__header">
            <h3>
              Hey 👋,
              <br /> I am <span>PARTH JAIN</span>
            </h3>
          </div>
          <div className="home__subtitle">
            <h4>CSE UnderGrad at IIT-RPR</h4>
          </div>
          <div className="home__actionbtn" >
          <Link
            activeClass="active"
            spy={true}
            smooth="easeInOutCubic"
            offset={40}
            duration={100}
            to="projects"
          >
              <span className="btn workbtn">My Work</span>
            </Link>
            <Link
            activeClass="active"
            spy={true}
            smooth="easeInOutCubic"
            offset={50}
            duration={100}
            to="contact"
          >
              <span className="btn hirebtn">Contact Me</span>
            </Link>
          </div>
        </div>
        <div className="right">
          <img src={pic} alt="home"/>
        </div>
      </div>
    </section>
  );
};

export default Home;
